import { type SupportedLocale } from '@zep-us/i18n';

import { CMS_CDN } from '@/consts/env';

export type PictureLinksGroup =
  | 'default'
  | 'europe'
  | 'southeastAsia'
  | 'middleAsia';

// 후기 이미지 path
export const PICTURE_LINKS_BY_GROUP: Record<PictureLinksGroup, string[]> = {
  // 한국, 일본, 대만, 중국
  default: [
    `${CMS_CDN}/medias/9z7bCJzn/4Ep/VowDJ3wK87durTq3vthO4Ep/en-US/1/1_2x.webp`,
    `${CMS_CDN}/medias/9z7bCJzn/SLU/gVFiP3wK87curTq3vsVaSLU/en-US/1/2_2x.webp`,
    `${CMS_CDN}/medias/9z7bCJzn/SYn/FkuyJ3wK87curTq3vHNfSYn/en-US/1/3_2x.webp`,
    `${CMS_CDN}/medias/9z7bCJzn/wi7/CQhbi3wK87curTq3vEQywi7/en-US/1/4_2x.webp`,
    `${CMS_CDN}/medias/9z7bCJzn/lku/r6pdh3wK87durTq3vFP6lku/en-US/1/5_2x.webp`,
    `${CMS_CDN}/medias/9z7bCJzn/uoM/JoMBk3wK87curTq3vGSruoM/en-US/1/6_2x.webp`,
    `${CMS_CDN}/medias/9z7bCJzn/0ad/8M3IJ3wK87durTq3vH5y0ad/en-US/1/7_2x.webp`,
  ],
  // 유럽, 브라질, en
  europe: [
    '/assets/landing/introduction/photos/europe/eu-1.webp',
    '/assets/landing/introduction/photos/europe/eu-2.webp',
    '/assets/landing/introduction/photos/europe/eu-3.webp',
    '/assets/landing/introduction/photos/europe/eu-4.webp',
    '/assets/landing/introduction/photos/europe/eu-5.webp',
    '/assets/landing/introduction/photos/europe/eu-6.webp',
    '/assets/landing/introduction/photos/europe/eu-7.webp',
    '/assets/landing/introduction/photos/europe/eu-8.webp',
  ],
  // 동남아시아
  southeastAsia: [
    '/assets/landing/introduction/photos/southeast-asia/sa-1.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-2.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-3.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-4.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-5.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-6.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-7.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-8.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-9.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-10.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-11.webp',
    '/assets/landing/introduction/photos/southeast-asia/sa-12.webp',
  ],
  // 중앙아시아, 중동
  middleAsia: [
    '/assets/landing/introduction/photos/middle-asia/ma-1.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-2.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-3.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-4.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-5.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-6.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-7.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-8.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-9.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-10.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-11.webp',
    '/assets/landing/introduction/photos/middle-asia/ma-12.webp',
  ],
};

export const PICTURE_GROUP_TO_LOCALE: Array<{
  name: PictureLinksGroup;
  locales: SupportedLocale[];
}> = [
  { name: 'default', locales: ['ko', 'ja', 'zh-TW', 'zh-CN', 'zh-HK'] },
  {
    name: 'europe',
    locales: [
      'fr',
      'pt',
      'pt-BR', // 브라질
      'es',
      'it',
      'de',
      'ru',
      'en',
      'nl', // 네덜란드
      'pl', // 폴란드
      'et', // 에스토니아
      'fi', // 핀란드
    ],
  },
  {
    name: 'southeastAsia',
    locales: [
      'vi',
      'fil',
      'th',
      'ms',
      'id',
      'km',
      'en-SG', // 싱가포르
    ],
  },
  {
    name: 'middleAsia',
    locales: [
      'tr', // 터키
      'uz',
      'hi-IN', // 인도
      'bn-IN', // 인도 (벵골어)
      'te-IN', // 인도 (텔루구어)
      'pa-IN', // 인도 (펀자브어)
      'ml-IN', // 인도 (말라얄람어)
      'ta-IN', // 인도 (타밀어)
    ],
  },
];
